import React from 'react'
import { PageWrapper } from '../components/PageWrapper'
import { Text } from 'base-ui'

const SpacingUnits = () => {
    const spacingBackground = "bg-red-300 inline-block h-4"
    const gridRow = "grid grid-cols-4 gap-4 mb-4"
  return (
    <PageWrapper title="Spacing Units">
        <Text size="lg">Spacing units are the space proportion used to construct and separate all elements on a page.</Text>
        <Text size="md">
            Paro's spacing system is based on multiples of 2px, with 8px being the base unit.
            Use space units to add padding or margin to an element or area.
            The corresponding size units for tailwind are shown below.
        </Text>
        <div className={`${gridRow} mt-6 font-bold`}>
            <div> Tailwind </div>
            <div> rem </div>
            <div> px </div>
            <div> Size </div>
        </div>
        <div className={`${gridRow}`}>
            <div> 0.5 </div>
            <div> 0.125rem </div>
            <div> 2px </div>
            <div> <div className={`${spacingBackground} w-0.5`}></div> </div>
        </div>
        <div className={`${gridRow}`}>
            <div> 1 </div>
            <div> 0.25rem </div>
            <div> 4px </div>
            <div> <div className={`${spacingBackground} w-1`}></div> </div>
        </div>
        <div className={`${gridRow}`}>
            <div> 2 </div>
            <div> 0.5rem </div>
            <div> 8px </div>
            <div> <div className={`${spacingBackground} w-2`}></div> </div>
        </div>
        <div className={`${gridRow}`}>
            <div> 4 </div>
            <div> 1rem </div>
            <div> 16px </div>
            <div> <div className={`${spacingBackground} w-4`}></div> </div>
        </div>
        <div className={`${gridRow}`}>
            <div> 8 </div>
            <div> 2rem </div>
            <div> 32px </div>
            <div> <div className={`${spacingBackground} w-8`}></div> </div>
        </div>
        <div className={`${gridRow}`}>
            <div> 16 </div>
            <div> 4rem </div>
            <div> 64px </div>
            <div> <div className={`${spacingBackground} w-16`}></div> </div>
        </div>
        <div className={`${gridRow}`}>
            <div> 32 </div>
            <div> 8rem </div>
            <div> 128px </div>
            <div> <div className={`${spacingBackground} w-32`}></div> </div>
        </div>
        <Text size="md">
            Although the units above represent the general spacing proportions that elements are expected to have inside them as well as in relation to other elements on the page,
            all Tailwind classes can be used to achieve those proportions. Please refer to the full list of available classes: <a target="blank" className="underline" href="https://tailwindcss.com/docs/customizing-spacing#default-spacing-scale">Tailwind custom spacing</a>.
        </Text>
    </PageWrapper>
  )
}

export default SpacingUnits
